export function removeQueryStringAndHash(asPath = ''): string {
  return asPath.replace(/(\?|\#).*$/, '').replace(/\/$/, '')
}
